export default {
  checkout: {
    defaultCouponError: 'Gutscheincode ungültig',
    back: 'Zurück',
    registration: 'Kontakt',
    login: {
      yourAccount: 'Dein Konto',
      enterEmail: 'E-Mail eingeben und starten',
      login: 'Log Dich in Dein konfetti Konto ein',
      register: 'Erstelle Dein Konto',
    },
    yourAccount: 'Dein Konto',
    createAccount: 'Kontakt',
    checkout: 'Zahlungsdetails',
    done: ' Fertig',
    confirmOrder: 'Bestellung absenden',
    review: 'Überprüfe',
    payment: 'Zahlung',
    userRegistered: 'Log Dich in Dein konfetti Konto ein',
    userNotRegistered: 'Erstelle Dein Konto',
    userUnknown: 'E-Mail eingeben und starten',
    emptyCartMessage: 'Dein Warenkorb ist leer.',
    surveyTitle: 'Bitte teile uns mit, wo Du von konfetti gehört hast?',
    register: 'Register',
    continue: 'Weiter',
    forgotPassword: 'Passwort vergessen?',
    or: 'oder',

    newsletter:
      'Ja, ich möchte per E-Mail-Newsletter über Trends und Aktionen informiert werden. Abmeldung jederzeit möglich. (optional)',

    legalCopy:
      'Mit Deiner Bestellung erklärst Du Dich mit unseren {privacyPolicy}, {termsAndConditions} und {cancellationPolicy} einverstanden. Als Kunde von gokonfetti.com erhältst Du Produktempfehlungen per Mail, von denen Du Dich jederzeit über einen Link in der Mail abmelden kannst.',
    termsAndConditions: 'AGB',
    privacyPolicy: 'Datenschutzbestimmungen',
    cancellationPolicy: 'Widerrufsbestimmungen',

    personalDetails: {
      loginButton: 'Anmelden',
      logoutButton: 'Abmelden',
      fillDetails: 'oder fülle folgende Details aus:',
      loginMessage: 'Schon registriert?',
      logoutMessage: 'Das bist nicht Du?',
      accountPerks:
        'Genieße folgende Vorteile mit Deinem kostenlosen konfetti Konto!',
      socialLogin: {
        facebook: 'Weiter mit Facebook',
        apple: 'Weiter mit Apple',
        google: 'Weiter mit Google',
      },
      form: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        companyName: 'Firmenname (für Firmenkunden)',
        email: 'E-Mail',
        password: 'Passwort',
        phone: 'Telefonnummer',
      },
      validation: {
        phone: {
          min: 'Die Telefonnummer muss mindestens {min} Ziffern lang sein',
          max: 'Die Telefonnummer darf nicht länger als {max} Ziffern sein',
        },
      },
    },

    addedToCart: 'Erfolgreich zum Warenkorb hinzugefügt',

    paymentDetails: {
      paymentErrorMessage:
        "Bei Deiner Zahlung ist etwas schief gelaufen. Bitte kontaktiere uns unter <u>+30219843293</u> oder sende eine E-Mail an <u>hallo{'@'}gokonfetti.com</u>",
      methods: {
        creditCard: 'Kartenzahlung',
        paypal: 'Mit PayPal bezahlen',
        balance: 'Mit Guthaben bezahlen',
        sepa: 'Mit SEPA bezahlen',
        giftcard: 'Mit Gutschein bezahlen',
        invoice: 'Per Rechnung bezahlen',
      },
      form: {
        title: 'Rechnungsadresse',
        productList: 'Produktliste',
        invoice: 'Ich benötige eine Rechnung',
        paymentMethods: 'Zahlungsart',
        or: 'oder',
        invoiceLabel: 'Rechnung',
        pay: 'Bezahlen',
        payWithCard: 'Zahlungspflichtig bestellen',
        payWithPaypal: 'Mit PayPal bezahlen',
        payWithKlarna: 'Mit Klarna bezahlen',
        payWithInvoice: 'Mit Rechnung bezahlen',
        payWithGiftcard: 'Mit Gutschein bezahlen',
        payWithSEPA: 'Zahlungspflichtig bestellen',
        payWithBalanceAndCoupon: 'Mit Gutschein und Guthaben bezahlen',
        payWithBalance: 'Mit Guthaben bezahlen',
        notAvailableForGiftcards:
          'Diese Zahlungsmethode ist für Gutscheine nicht verfügbar.',
        errors: {
          name: 'Der Name des Karteninhabers wird benötigt.',
        },
        card: {
          expirationDate: 'Gültigkeit:',
          whereIsMyCvc: 'Wo finde ich meine Kartenprüfnummer?',
          keep: 'Kartendetails für spätere Käufe speichern.',
          number: 'Nummer',
          holder: 'Karteninhaber',
          cvc: 'Kartenprüfnummer',
        },
      },
    },

    shippingDetails: {
      title: 'Lieferadresse',
      form: {
        firstName: 'Vorname',
        apartment: 'Apartment',
        lastName: 'Nachname',
        street: 'Straße',
        streetNumber: 'Hausnummer',
        locality: 'Stadt',
        state: 'Bundesland',
        zipcode: 'Postleitzahl',
        country: 'Land',
        phoneNumber: 'Telefon',
        additional: 'Zusätzliche Informationen',
        dateOfBirth: 'Geburtsdatum',
      },
    },

    invoiceDetails: {
      title: 'Rechnungsadresse',
      form: {
        firstName: 'Vorname',
        apartment: 'Apartment',
        lastName: 'Nachname',
        companyName: 'Firmenname',
        street: 'Straße',
        streetNumber: 'Hausnummer',
        locality: 'Stadt',
        state: 'Bundesland',
        zipcode: 'Postleitzahl',
        country: 'Land',
        phoneNumber: 'Telefon',
        vat: 'USt-ID',
        sameAddressAsShipping: 'Rechnungsadresse gleicht Versandadresse',
        poNumber: 'PO Nummer/Einkaufsnummer/Spezielle Anmerkungen',
      },
    },

    // Invoice payment terms
    invoicePayment: {
      title: 'Rechnungszahlungsbedingungen',
      terms: {
        giftCardOnly: {
          paymentDue: 'Zahlung ist in 14 Tagen fällig',
          invoiceSent: 'Rechnung wird sofort per E-Mail versendet',
          giftCardIssued: 'Gutschein wird nach Geldeingang ausgestellt',
        },
        ticketOnly: {
          paymentDue: 'Zahlung ist in {days} Tagen fällig',
          invoiceSent: 'Rechnung wird sofort per E-Mail versendet',
          ticketSent: 'Ticket wird nach dem Checkout versendet',
        },
        mixed: {
          paymentDue: 'Zahlung ist in 14 Tagen fällig',
          invoiceSent: 'Rechnung wird sofort per E-Mail versendet',
          giftCardIssued: 'Gutschein wird nach Geldeingang ausgestellt',
        },
      },
      paymentDueDates: {
        days14to30: '7 Tage ab Bestelldatum',
        days31to60: '14 Tage ab Bestelldatum',
        days60plus: '30 Tage ab Bestelldatum',
      },
    },

    steps: {
      contact: 'Kontakt',
      payment: 'Zahlung',
      summary: 'Fertig',
      details: 'Setup Details',
      review: 'Bestellung überprüfen',
      continue: 'Nächster Schritt',
    },

    stepConfirmOrder: {
      title: 'Deine Bestellung',
      subtotal: 'Zwischensumme',
      total: 'Gesamtsumme (inkl. MwSt.)',
      iAgreeWith: 'Ich stimme zu ',
      termsAndConditions: 'AGB',
    },

    orderReview: {
      title: 'Bestellung überprüfen',
      personalDetails: 'Persönliche Details',
      shippingDetails: 'Lieferadresse',
      billingAddress: 'Rechnungsadresse',
      sameAsShippingAddress: 'Entspricht meiner Lieferadresse',
      paymentMethod: 'Zahlungsart',
      promoCode: 'Gutschein eingeben',
    },

    orderSummary: {
      subtotal: 'Zwischensumme',
      giftboxPrice: 'Geschenkverpackung',
      shippingPrice: 'Versand',
      total: 'Total',
      items: 'Artikel',
      grandTotal: 'Gesamtsumme (inkl. MwSt.)',
      balance: 'Kundenguthaben',
      promoCode: 'Gutscheincode',
      discount: 'Rabatt',
      shipping: 'Versand',
      shippingInfo: 'Der Versand dauert 3-5 Werktage.',
      voucher: 'Gutschein eingeben',
      voucherSuccess: 'Gutschein angewendet',
      yourOrder: 'Deine Bestellung',
      eventType: {
        kit: 'Kit',
        giftcard: 'Gutschein',
      },
      adjustments: 'Anpassungen',
    },

    termsModalTitle: 'AGB',
    acceptTermsSpanText:
      'Mit Deiner Bestellung erklärst Du Dich mit unseren Datenschutzbestimmungen, AGB und Widerrufsbestimmungen einverstanden. Als Kunde von gokonfetti.com erhältst Du Produktempfehlungen per Mail, von denen Du dich jederzeit über einen Link in der Mail abmelden kannst.',
    acceptTermsSpanTerms: 'AGB',

    success: {
      title: 'Fantastisch - die Bestellung war erfolgreich.',
      titleInvoice: 'Überprüfe Deine E-Mails für Deine Rechnung',
      orderNo: 'Bestellnummer:',
      invoiceDueDate: 'Rechnungsfälligkeitsdatum',
      copy: 'Wir haben Dir Deine Bestellbestätigung per E-Mail zugesendet.',
      copyInvoice: 'Du erhältst Deine Bestellbestätigung nach der Zahlung',
      orders: 'Zu Deiner Bestellung gehen',
      addToCalendar: 'Zum Kalendar hinzufügen',
      homeButton: 'Zur Startseite',
      referralInfo: {
        title:
          'Noch mehr konfetti: Empfehle uns weiter und Ihr erhaltet beide 20 €.',
        text: 'Geben Sie Ihren Empfehlungscode an Freunde weiter und Sie erhalten beide 20 € Rabatt auf Ihren nächsten Einkauf!',
      },
    },

    pending: {
      title:
        'Vielen Dank für Dein Vertrauen, Deine Bestellung wird gerade bearbeitet',
    },

    errors: {
      onePlusEventsWithoutEnoughTicketsError:
        'Our system has removed several items from your cart, for they are currently sold out. Please try to book for another date.',
      paymentFailed:
        'Die Zahlung war nicht erfolgreich. Bitte versuchen Sie es erneut',

      // Most of these come from:
      // https://bitbucket.org/gokonfetti/backend/src/develop/source/app/Containers/CheckoutSection/Payment/README.md
      unauthenticated:
        'Sie sind nicht eingeloggt. Bitte melden Sie sich erneut an',
      gatewayUnauthorized:
        'Die Zahlungstransaktion wurde nicht autorisiert. Bitte versuchen Sie es erneut',
      cardDeclined: 'Die Karte wurde abgelehnt. Bitte versuchen Sie es erneut',
      invalidGateway:
        'Es gab ein Problem mit Ihrer Zahlung. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut',
      invalidPaymentMethod:
        'Es gab ein Problem mit Ihrer Zahlung. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut',
      invalidPaymentSignature:
        'Es gab ein Problem mit Ihrer Zahlung. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut',
      invalidValueCaptured:
        'Der Gesamtpreis scheint nicht korrekt zu sein. Bitte überprüfen Sie Ihren Warenkorb und versuchen Sie es erneut',
      invalidValueInformed:
        'Der Gesamtpreis scheint nicht korrekt zu sein. Bitte überprüfen Sie Ihren Warenkorb und versuchen Sie es erneut',
      invalidValueRefundedCaptured:
        'Der erstattete Wert weicht von der Transaktionssumme ab, bitte aktualisieren Sie und versuchen Sie es erneut',
      actionRequired:
        'Es ist ein zusätzlicher Sicherheitsschritt erforderlich. Bitte befolgen Sie die Anweisungen, die angezeigt werden',
      confirmationRequired:
        'Es ist ein zusätzlicher Sicherheitsschritt erforderlich. Bitte bestätigen Sie die Transaktion',
    },

    allItemsRemoved:
      'Alle Artikel wurden aus Deinem Warenkorb entfernt. Du wirst weitergeleitet...',

    stripePayment: {
      stripe3DAuth: {
        alerts: {
          succeeded: {
            title: 'Super!',
            message: 'Bestätigung war erfolgreich!',
          },
          requires_action: {
            title: 'Error',
            message:
              'Die Angaben stimmen nicht überein, bitte versuche es noch einmal.',
          },
          requires_payment_method: {
            title: 'Error',
            message: 'Zahlungsmethodenfehler, bitte versuche es noch einmal.',
          },
        },
      },
    },

    sessionVoucher: {
      successMessage:
        'Erfolg! Dein Gutschein wurde angewendet. Du sparst {amount}.',
      reminderMessage:
        'Dein {amount} Rabatt ist noch verfügbar, Jetzt einlösen!',
      errorMessage: 'Der Gutscheincode konnte nicht gespeichert werden.',
      minimumOrderValueMessage:
        'Füge {amount} hinzu, um den Mindestbestellwert für den Gutschein zu erreichen.',
    },

    validation: {
      required: 'Dieses Feld ist erforderlich',
      email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      min: 'Muss mindestens {min} Zeichen lang sein',
      phone: {
        min: 'Die Telefonnummer muss mindestens {min} Ziffern lang sein',
        max: 'Die Telefonnummer darf nicht länger als {max} Ziffern sein',
      },
    },

    countries: {
      de: 'Deutschland',
      at: 'Österreich',
    },

    paymentError: {
      paymentErrorMessage:
        "Bei Deiner Zahlung ist etwas schief gelaufen. Bitte kontaktiere uns unter <u>+30219843293</u> oder sende eine E-Mail an <u>hallo{'@'}gokonfetti.com</u>",
      paymentDeniedMessage:
        "Bei Deiner Zahlung ist etwas schief gelaufen. Bitte kontaktiere uns unter <u>+30219843293</u> oder sende eine E-Mail an <u>hallo{'@'}gokonfetti.com</u>",
      paymentProcessingMessage:
        "Bei Deiner Zahlung ist etwas schief gelaufen. Bitte kontaktiere uns unter <u>+30219843293</u> oder sende eine E-Mail an <u>hallo{'@'}gokonfetti.com</u>",
    },
    priceUpdatedNotification:
      'Der Preis eines Artikels in Deinem Warenkorb wurde aktualisiert. Bitte überprüfe Deine Bestellung und versuche es erneut.',
    guestCheckout: {
      title: 'Als Gast fortfahren',
      description:
        'Schließe Deine Bestellung schnell ab – ganz ohne Kundenkonto.',
      button: 'Als Gast fortfahren',
    },
  },
}
